import React, { useState } from 'react';

const COMPANY_ICONS = {
  perpetue: '🏥',
  ioa: '✨',
};

const DEFAULT_ICON = '🏢';

export default function WorkspaceSelector({ companies, onSelect, onAddCompany }) {
  const [showForm, setShowForm] = useState(false);
  const [newName, setNewName] = useState('');
  const [newColor, setNewColor] = useState('#6366f1');

  const handleAdd = () => {
    if (!newName.trim()) return;
    onAddCompany({ name: newName.trim(), color: newColor });
    setNewName('');
    setNewColor('#6366f1');
    setShowForm(false);
  };

  const s = {
    screen: {
      height: '100vh',
      background: '#0f0f11',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 32,
    },
    logo: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 },
    logoIcon: {
      width: 52, height: 52, background: '#6366f1', borderRadius: 14,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 26, fontWeight: 700, color: '#fff',
    },
    logoText: { fontSize: 24, fontWeight: 700, color: '#e4e4e7', letterSpacing: '-0.5px' },
    logoSub: { fontSize: 13, color: '#52525b', marginTop: -6 },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: 12,
      width: '100%',
      maxWidth: 540,
      padding: '0 24px',
    },
    card: (color) => ({
      background: '#1c1c1f',
      border: '1px solid #27272a',
      borderRadius: 12,
      padding: '20px 18px',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      transition: 'border-color 0.15s, background 0.15s',
    }),
    cardIcon: (color) => ({
      width: 36, height: 36, borderRadius: 10,
      background: color + '22', border: `1px solid ${color}44`,
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
    }),
    cardName: { fontSize: 14, fontWeight: 600, color: '#e4e4e7' },
    cardSub: { fontSize: 12, color: '#71717a' },
    cardArrow: { fontSize: 16, color: '#52525b', marginTop: 4 },
    addCard: (active) => ({
      background: active ? '#1c1c1f' : 'transparent',
      border: active ? '1px solid #3f3f46' : '1.5px dashed #3f3f46',
      borderRadius: 12,
      padding: '20px 18px',
      cursor: active ? 'default' : 'pointer',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      transition: 'all 0.15s',
    }),
    addIcon: { fontSize: 22, color: '#3f3f46' },
    addText: { fontSize: 13, color: '#52525b' },
    form: { display: 'flex', flexDirection: 'column', gap: 8 },
    formLabel: { fontSize: 11, color: '#71717a', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' },
    formInput: {
      padding: '7px 10px', background: '#18181b', border: '1px solid #3f3f46',
      borderRadius: 6, color: '#e4e4e7', fontSize: 13, outline: 'none', width: '100%',
    },
    formRow: { display: 'flex', gap: 6, alignItems: 'center' },
    btnAdd: {
      flex: 1, padding: '7px', background: '#6366f1', border: 'none',
      borderRadius: 6, color: '#fff', fontSize: 12, fontWeight: 500, cursor: 'pointer',
    },
    btnCancel: {
      padding: '7px 10px', background: 'transparent', border: '1px solid #3f3f46',
      borderRadius: 6, color: '#71717a', fontSize: 12, cursor: 'pointer',
    },
    footer: { fontSize: 12, color: '#3f3f46', marginTop: 8 },
  };

  return (
    <div style={s.screen}>
      <div style={s.logo}>
        <div style={s.logoIcon}>Z</div>
        <div style={s.logoText}>Omni</div>
        <div style={s.logoSub}>Selecione o workspace</div>
      </div>

      <div style={s.grid}>
        {companies.map(company => (
          <div
            key={company.id}
            style={s.card(company.color)}
            onClick={() => onSelect(company.id)}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = company.color + '88';
              e.currentTarget.style.background = company.color + '0a';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = '#27272a';
              e.currentTarget.style.background = '#1c1c1f';
            }}
          >
            <div style={s.cardIcon(company.color)}>
              {COMPANY_ICONS[company.id] || DEFAULT_ICON}
            </div>
            <div>
              <div style={s.cardName}>{company.name}</div>
              <div style={s.cardSub}>
                {company.instanceCount || 0} instância{company.instanceCount !== 1 ? 's' : ''}
              </div>
            </div>
            <div style={s.cardArrow}>Entrar →</div>
          </div>
        ))}

        {/* Add company card */}
        <div style={s.addCard(showForm)} onClick={() => !showForm && setShowForm(true)}>
          {!showForm ? (
            <>
              <div style={s.addIcon}>+</div>
              <div style={s.addText}>Nova empresa</div>
            </>
          ) : (
            <div style={s.form} onClick={e => e.stopPropagation()}>
              <div style={s.formLabel}>Nova empresa</div>
              <input
                style={s.formInput}
                placeholder="Nome da empresa"
                value={newName}
                onChange={e => setNewName(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleAdd()}
                autoFocus
              />
              <div style={s.formRow}>
                <input
                  type="color"
                  value={newColor}
                  onChange={e => setNewColor(e.target.value)}
                  style={{ width: 32, height: 30, border: 'none', background: 'none', cursor: 'pointer', flexShrink: 0 }}
                />
                <button style={s.btnAdd} onClick={handleAdd}>+ Adicionar</button>
                <button style={s.btnCancel} onClick={() => { setShowForm(false); setNewName(''); }}>✕</button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div style={s.footer}>omni.perpe.pro</div>
    </div>
  );
}
